import React from "react";
import "./VfbNews.css";
import image1 from "../../Assets/11742771-vfb-joberg.webp";
import image2 from "../../Assets/11760342-ongm9884.webp";
import image3 from "../../Assets/11771342-1000196402 (1).webp";

const newsData = [
  {
    id: 1,
    title: "Ein Verein, der das soziale Leben und Miteinander mehr und mehr bereichert",
    date: "Unbekannt",
    excerpt: "Ein Verein, der das soziale Leben und Miteinander mehr und mehr bereichert.",
    image: image3, 
    link: "https://osthessen-news.de/n11771342/ein-verein-der-das-soziale-leben-und-miteinander-mehr-und-mehr-bereichert.html"
  },
  {
    id: 2,
    title:"Wenigstens ein Stück vom großen Akzeptanz- und Wahrnehmungs-Kuchen",
    date: "23.03.2025",
    excerpt: "Der neue Coach setzt auf offensive Taktiken und Teamgeist.",
    image: image1,
    link: "https://osthessen-news.de/n11742771/wenigstens-ein-stueck-vom-grossen-akzeptanz-und-wahrnehmungs-kuchen.html"
  },
  {
    id: 3,
    title: "Ein Verein mitten aus Bad Hersfelds Leben rückt in den Fokus",
    date: "12.05.24 ",
    excerpt: "Ein Verein mitten aus Bad Hersfelds Leben rückt in den Fokus.",
    image: image2,
    link: "https://osthessen-news.de/n11760342/ein-verein-mitten-aus-bad-hersfelds-leben-rueckt-in-den-fokus.html"
  }
];

function VfbNews() {
    return (
        <section className="vfb-news" id="news">
          <div className="container">
            <h2 className="section-title">VfB Neuigkeiten</h2>
            <div className="row">
              {newsData.map((news, index) => (
                <div className="col-md-4 col-12 mb-4" key={index}>
                  <div className="news-card">
                    <img src={news.image} alt={news.title} className="news-image" />
                    <div className="news-content">
                      <h5 className="news-title">{news.title}</h5>
                      <p className="news-date">{news.date}</p>
                      <p className="news-description">{news.description}</p>
                      <a href={news.link} target="_blank" rel="noopener noreferrer" className="news-btn">
                        Mehr lesen
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      );
    }

export default VfbNews;